module.exports = __webpack_public_path__ + "img/full5-min.c13d437d.png";